export const FEATURE_NAME = '@vshosting/cdn/features/edit-domain-dialog/edit-domain-dialog';
